import { getPointer, getLenis } from "@js/utils";
class NextHero extends HTMLElement {
    constructor() {
        super();
        this.tlScale;
        this.tlThree;
    }
    connectedCallback() {
        this.init();
    }
    init() {
        this.setup()
        this.initThree();
    }
    setup() {
        const scaleFont = { 
            dsk: 12/7.2,
            tb: 8/6, 
            mb: 1
        }
        this.tlScale = gsap.timeline({
            paused: true,
            onStart: () => {
                // this.tlThree.play();
            },
            onComplete: () => {
                this.querySelector('.next-hero').classList.add('already');
                this.querySelector('.next-hero-inner-main.placeholder').remove();
            }
        })
        
        let textMain = this.querySelector('.next-hero-inner-main.main .next-hero-title-wrap');
        let textPlaceholder = this.querySelector('.next-hero-inner-main.placeholder .next-hero-title-wrap');
        
        let scaleDistance = textPlaceholder.querySelector('.next-hero-title').clientHeight * (scaleFont[getScreenType().type]) - textPlaceholder.querySelector('.next-hero-title').clientHeight;
        gsap.set(textPlaceholder.querySelector('.next-hero-title'), { height: textPlaceholder.querySelector('.next-hero-title').clientHeight + scaleDistance })
        gsap.set(textPlaceholder, { top: ((window.innerHeight - textPlaceholder.clientHeight) / 2) - parseFloat(getComputedStyle(this.querySelector('.next-hero')).paddingTop) })

        this.tlScale
            .to(textPlaceholder, {
                top: textMain.offsetTop,
                transformOrigin: 'top center',
                duration: 1.2,
                ease: 'power2.inOut',
                overwrite: true,
            })
            .to(textPlaceholder.querySelector('.next-hero-title'), {
                height: textMain.querySelector('.next-hero-title').clientHeight,
                transformOrigin: 'top center',
                scale: 1,
                ease: 'power2.inOut',
                duration: 1.2,
            }, 0)

        new MasterTimeline({
            triggerInit: this, timeline: gsap.timeline({
                onStart: () => {
                this.querySelectorAll('[data-init-df]').forEach((el) => {el.removeAttribute('data-init-df')});
            }}), tweenArr: [
            new FadeIn({ el: this.querySelector('.next-hero-inner-main.placeholder .next-hero-logo'), allowMobile: true }),
            new RevealText({ el: this.querySelector('.next-hero-inner-main.placeholder .next-hero-title .txt'), color: 'white', delay: "<=.2", allowMobile: true }),
            new FadeSplitText({ el: this.querySelector('.next-hero-inner-main.placeholder .next-hero-sub .txt'), breakType: 'words', allowMobile: true }),
            new FadeIn({ el: this.querySelector('.next-hero-inner-main.placeholder .next-hero-btn'), allowMobile: true }),
        ]})
    }
    initThree() {
        const { type, isMobile } = getScreenType()
        const scaleMap = {
            mb: 6,
            tb: 6,
            dsk: (() => {
                const aspectRatio = window.innerWidth / window.innerHeight;
                return aspectRatio < 1.77 ? 10 : Math.max(9 - (aspectRatio - 1.77) * 3.5, 5);
            })()
        }[type];

        const scene = new THREE.Scene();
        const el = this.querySelector('.next-hero-machine-canvas');
        const camera = new THREE.PerspectiveCamera(15, el.clientWidth / el.clientHeight, 0.1, 1000);
        const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
        renderer.setPixelRatio(window.devicePixelRatio);
        renderer.setSize(el.clientWidth, el.clientHeight);
        renderer.domElement.style.position = 'absolute';
        renderer.domElement.style.top = '0';
        renderer.domElement.style.left = '0';
        renderer.toneMapping = THREE.LinearToneMapping;
        renderer.encoding = THREE.sRGBEncoding;
        renderer.physicallyCorrectLights = true;
        el.appendChild(renderer.domElement);

        const loader = new GLTFLoader();
        const dracoLoader = new DRACOLoader();
        dracoLoader.setDecoderPath('https://www.gstatic.com/draco/v1/decoders/');
        loader.setDRACOLoader(dracoLoader);
        this.obj;
        camera.position.set(0, 0, 19.5);
        camera.lookAt(0, 0, 0);

        const path = this.getAttribute('data-glb');

        this.mouseFollow = {value: 1};
        this.mouseLock = true;
        loader.load(path, (gltf) => {
            this.obj = gltf.scene;
            this.obj.scale.set(scaleMap, scaleMap, scaleMap);
            this.obj.position.set(0, -2.35, 0);
            this.obj.rotation.x = Math.PI * -.0135;
            let toRemove = [];
            this.obj.children[0].children.map((child) => {
                if (child.name.includes('roti')) {
                    toRemove.push(child)
                }
            })
            toRemove.map((child) => {
                this.obj.children[0].remove(child);
                child.geometry.dispose();
                scene.remove(child)
                child.remove();
            })
            gltf.scene.traverse((child) => {
                if (child instanceof THREE.Mesh) {
                    switch (child.name) {
                    case 'screen_remove':
                        this.screen = child;
                        this.video = document.getElementById('videoMaterial');
                        this.video.currentTime = 0;
                        requestAnimationFrame(() => {
                            this.video.pause();
                        })
                        const texture = new THREE.VideoTexture( this.video );
                        texture.minFilter = THREE.LinearFilter;
                        texture.magFilter = THREE.LinearFilter;
                        texture.flipY = false;
                        texture.center = new THREE.Vector2(0.5, 0.5);
                        texture.scale = new THREE.Vector2(1.2, 1.2);
                        texture.format = THREE.RGBFormat;
                        this.screen.material.map = texture;
                        this.screen.material.needsUpdate = true;
                        this.screen.material.emissiveMap = texture;
                        this.screen.material.transparent = true;
                        this.screen.material.opacity = 0;
                        this.screen.emissiveIntensity = 1;
                        break;
                    case 'Boss-Extrude51':
                        child.material.color = new THREE.Color(0x1F1F1F);
                        break;
                    case 'Move_Face13_649':
                        child.material.metalness = 1;
                        child.material.roughness = 0.2;
                        break;
                    case 'Move_Face13_658_2':
                        child.material.metalness = .6;
                        child.material.opacity = .95;
                        break;
                    case 'Fillet8_412':
                        child.material.roughness = 0;
                        break;
                    case 'Fillet4':
                        child.material.specularIntensity = 0.9;
                        child.material.roughness = 0.3;
                        break;
                    }
                }
            })
            scene.add(this.obj);
            this.tlThree = gsap.timeline({
                onStart: () => {
                    setTimeout(() => {
                        this.tlScale.play()
                    }, 350);
                },
                onComplete: () => {
                    this.mouseLock = false; 
                    scrubTl();
                    document.querySelector('body').classList.contains('is-loading')  &&  document.querySelector('body').classList.remove('is-loading')
                },
                defaults: {
                    ease: 'power2.out',
                }
            });
            let timeScale = .8;
            this.tlThree
                .fromTo(scene, { environmentIntensity: .0 }, { environmentIntensity: .9, ease: 'power2.inOut', duration: timeScale * 1.4}, 1)
                .fromTo(this.screen.material, {opacity: 0}, {opacity: 1, duration: timeScale * 1.8, onStart: () => {this.video.play()}}, 1.6)
                .fromTo(camera.position, {z: 12}, {z: 19.5, duration: timeScale * 2.4, ease: 'power2.inOut'}, 0)
                .fromTo(this.obj.rotation, {y: Math.PI * .5}, {y: 0, duration: timeScale * 2.4, ease: 'power2.inOut'}, 0)
                .fromTo(this.obj.position, {y: -3.65}, {y: -2.35, duration: timeScale * 2.4, ease: 'power2.inOut'}, 0)
        }, undefined, (error) => console.error(error));
        const scrubTl = () => {
            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: this,
                    start: 'top top',
                    end: `bottom-=${window.innerHeight * 1} bottom`,
                    scrub: 1,
                },
                defaults: {
                    ease: 'none',
                }
            })
            let scaleFactor = Math.min(document.querySelector('.next-hero-block-title .container').clientWidth / document.querySelector('.next-hero-block-machine').clientWidth, 0.849438202247191) * 1.1772486772486772;
            tl
            .fromTo(this.mouseFollow, {value: 1}, {value: 0, duration: 1 * 1 / 5}, 0)
            .fromTo(this.querySelector('.next-hero-machine-fg'), { autoAlpha: .3 }, { autoAlpha: 0, duration: 1 * 1 / 5 }, 0)
            .set('.next-hero-block-title', { pointerEvents: 'none', duration: 0 })
            .set('.next-hero-block-content', { pointerEvents: 'auto', duration: 0 })
            .fromTo(this.obj.rotation, {x: Math.PI * -.0135}, {x: 0, duration: .4 * 3 / 5}, 0)
            .fromTo(this.obj.rotation, {y: 0}, {y: Math.PI * -.5, duration: 1 * 2.5 / 5}, 0)
            .fromTo(this.obj.position, {x: 0}, {x: .165, duration: 1 * 3 / 5}, 0)
            .fromTo(this.obj.position, {y: -2.35}, {y: 1 * scaleFactor, duration: 1 * 5 / 5}, 0)
            .fromTo(camera.position, {z: 19.5}, {z: 7.4 * scaleFactor, duration: 1 * 3 / 5}, 0)
            .fromTo(this.querySelector('.next-hero-content'), {yPercent: 320 * (1/scaleFactor)}, {yPercent: 0, duration: 1 * 2.5/5}, 1.8 / 5)
            .fromTo(this.querySelector('.next-hero-content'), {autoAlpha: 0}, {autoAlpha: 1, duration: .5 * 2/5}, 2.8 / 5)
            .fromTo(this.querySelector('.next-hero-machine-overlay'), {autoAlpha: 0}, {autoAlpha: 1, duration: 1 * 1/5}, isMobile ? 3/8 : 3/5)
            .fromTo(this.querySelector('.next-hero-machine-overlay'), {yPercent: 0}, {yPercent: -50, duration: 1 * 2.5/5}, 2.5/5)
            .fromTo(this, {autoAlpha: 1}, {autoAlpha: 1, duration: 1 * 5/5}, 0)

            const textSplit = new SplitType('.next-hero-content-inner .txt', { types: 'lines, words'});

            let color = 'black'
            const isColorDefault = color === 'white' || color === 'black' ;
            let fromColor = !isColorDefault ?  'rgba(255,255,255, .1)' : color == 'white' ? 'rgba(255,255,255, .1)' : 'rgba(29,29,29, .1)';
            let toColor =  !isColorDefault ? color :  color == 'white' ? 'rgba(255,255,255, 1)' : 'rgba(29,29,29, 1)' ;
            gsap.set(textSplit.words, {color: fromColor, overwrite: true})
            let tlTxt = gsap.timeline({
                scrollTrigger: {
                    trigger: this,
                    start: `bottom-=${window.innerHeight * (window.innerWidth > 767 ? 2 : 1.5 )} bottom`,
                    end: `bottom-=${window.innerHeight * (window.innerWidth > 767 ? .75 : 1 )} bottom`,
                    scrub: 1
                },
                defaults: {
                    ease: 'none',
                }
            })
            tlTxt.to(textSplit.words, {
                keyframes: {
                    color: [fromColor, '#FF6B30', toColor ],
                    easeEach: 'power2.in',
                    ease: 'power1.out',
                },
                overwrite: true,
                duration: .8,
                stagger: .03,
            })
        }
        const hdrLoader = new RGBELoader();
        const hdrPath = this.getAttribute('data-hdr');
        hdrLoader.load(hdrPath, (texture) => {
            texture.mapping = THREE.EquirectangularReflectionMapping;
            texture.encoding = THREE.sRGBEncoding;
            scene.environment = texture;
            scene.environmentIntensity = .9
            // scene.environmentRotation.y = Math.PI * .1;
        });
        function inView(el) {
            const rect = el.getBoundingClientRect();
            return (
                rect.top <= 0 &&
                rect.bottom - window.innerHeight * 2 >= 0
            );
        }
        const animate = () => {
            requestAnimationFrame(animate);
            if (inView(this)) {
                if (this.obj) {
                    let mouseX = this.obj.children[0].rotation.y;
                    let mouseY = this.obj.children[0].rotation.x;
                    let targetX = ((getPointer().x / window.innerWidth) - .5) / 2;
                    let targetY = ((getPointer().y / window.innerHeight) - .5) / 2;
                    if (this.mouseLock == false && window.innerWidth > 991) {
                        this.obj.children[0].rotation.y = (lerp(mouseX, -(Math.PI * .2 * targetX), .04)) * this.mouseFollow.value;
                        this.obj.children[0].rotation.x = (lerp(mouseY, -(Math.PI * .1 * targetY), .04)) * this.mouseFollow.value;
                    }
                }
                renderer.render(scene, camera);
            }
        };
        animate();
        function onWindowResize() {
            camera.aspect = el.clientWidth / el.clientHeight;
            camera.updateProjectionMatrix();
            renderer.setSize(el.clientWidth, el.clientHeight);
        }
        window.addEventListener('resize', onWindowResize);
    }
    interact() {
        const textSplit = new SplitType('.next-hero-content-inner .txt', { types: 'lines, words'});

        let distanceY = this.querySelector('.next-hero-inner').clientHeight - ((this.querySelector('.next-hero-inner').clientHeight - (this.querySelector('.next-hero-machine-inner').clientHeight * 1)) / 2) - this.querySelector('.next-hero-machine').clientHeight;
        let distanceX = this.querySelector('.next-hero-machine-inner').clientWidth * .25
        let scaleFactor = this.querySelector('.next-hero-inner').clientWidth / (this.querySelector('.next-hero-machine-side').clientHeight * .7276);
        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: this,
                start: 'top top',
                end: `bottom-=${window.innerHeight * 2} bottom`,
                scrub: true,
            },
            defaults: {
                ease: 'none',
            }
        })
        tl
        .fromTo(this.querySelector('.next-hero-machine-front'), {autoAlpha: 1}, {autoAlpha: 0, duration: .25})
        .fromTo(this.querySelector('.next-hero-machine-side'), {autoAlpha: 0}, {autoAlpha: 1, duration: .25}, 0)
        .fromTo(this.querySelector('.next-hero-machine-inner'), {x: 0, y: 0, scale: 1}, {x: distanceX, scale: scaleFactor, y: -distanceY * 2, duration: 1}, 0)
        .fromTo(this.querySelector('.next-hero-content'), {scale: 1 / (scaleFactor * .5), x: -distanceX * 0 * .25 , y: distanceY * .5, autoAlpha: 0}, {y: 0, x: 0, scale: 1, autoAlpha: 1, duration: .5}, 0.5)
        .fromTo(this.querySelector('.next-hero-machine-side-overlay'), {autoAlpha: 0}, {autoAlpha: 1, duration: .25}, .75)

        let tlTxt = gsap.timeline({
            scrollTrigger: {
                trigger: this,
                start: `bottom-=${window.innerHeight * 2.5} bottom`,
                end: `bottom-=${window.innerHeight * 1} bottom`,
                scrub: true,
            },
            defaults: {
                ease: 'none',
            }
        })
        tlTxt.from(textSplit.words, {color: 'rgba(72,72,72,.2)', duration: .1, stagger: .007})
    }
}

customElements.define('next-hero', NextHero);
